var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-view"},[_c('part-1'),_c('part-2'),_c('part-3')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }